import type { StrokeStyle } from "@/types/annotation";

// Dash lengths scale with the stroke so a dashed thick line still reads as
// dashed rather than as a row of blocks.
const DASH_RATIO = 3;
const GAP_RATIO = 2;

export const isDashed = (strokeStyle: StrokeStyle | undefined): boolean =>
  strokeStyle === "dashed";

/** Dash pattern for canvas `setLineDash`, or `[]` for a solid stroke. */
export const dashPattern = (
  strokeStyle: StrokeStyle | undefined,
  strokeWidth: number,
): number[] => {
  if (!isDashed(strokeStyle)) return [];
  const unit = Math.max(strokeWidth, 1);
  return [unit * DASH_RATIO, unit * GAP_RATIO];
};

/** Dash pattern for the SVG `stroke-dasharray` attribute, or undefined if solid. */
export const dashArray = (
  strokeStyle: StrokeStyle | undefined,
  strokeWidth: number,
): string | undefined => {
  const pattern = dashPattern(strokeStyle, strokeWidth);
  return pattern.length ? pattern.join(" ") : undefined;
};
